import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "@components/Header/Header";
import MuiButton from "@components/Button/MuiButton";
import CommonLoginHeader from "@components/Header/CommonLoginHeader";

function ErrorPageNotFound() {
  const navigate = useNavigate();

  const handleBackHome = () => {
    navigate("/");
  };

  return (
    <>
      <CommonLoginHeader/>
      <div className="text-center max-w-md w-full">
        <p className="font-bold brand-900 flex justify-center items-center error-title-bg">401</p>
        <p className="head-s font-bold gray-900 mb-2">We’re Sorry,</p>
        <p className="body-m font-medium mb-2 gray-900">
          The page you are looking for could not be found. Head back to the homepage to find your way.
        </p>
        <MuiButton
          variant="contained"
          name="Back To Homepage"
          sx={{
            borderRadius: "100px",
            fontWeight: `var(--font-medium)`,
            marginTop: "2.5rem",
            background: "var(--brand-900)",
          }}
          onClick={handleBackHome}
        />
      </div>
    </>
  )
}

export default ErrorPageNotFound;
